/* eslint-disable comma-dangle */
import api from '@/api';
import {
  CONFLICT, NOT_ACCEPTABLE, NOT_FOUND, UNAUTHORIZED, UNPROCESSABLE_ENTITY
} from '../../enums/errorEnums';

const baseAPI = `${process.env.VUE_APP_BASE_API}/indications`;
const HANDLED_ERRORS = [
  CONFLICT,
  NOT_ACCEPTABLE,
  CONFLICT,
  UNPROCESSABLE_ENTITY,
  UNAUTHORIZED,
  NOT_FOUND
];

const errorValidate = (response) => {
  let errors = null;
  const { status } = response;

  if (HANDLED_ERRORS.includes(status)) {
    errors = {
      status,
      statusText: response.statusText || response.data.message,
    };
  }

  return errors;
};

export default {
  sendIndication: async ({ payload }) => {
    const response = await api.post(baseAPI, payload);

    let errors = null;
    const { status } = response;
    console.log('teste');
    if (HANDLED_ERRORS.includes(status)) {
      errors = {
        status,
        statusText: response.statusText || response.data.message,
      };
    }

    const { data } = response;

    return {
      data,
      errors,
    };
  },
  getIndications: async () => {
    const response = await api.get(`${baseAPI}/MyIndications?includeJobs=true`);

    const errors = errorValidate(response);

    const { data } = response

    return {
      data,
      errors,
    };
  },
  getRecommendations: async () => {
    const response = await api.get(`${baseAPI}/MyRecommendations?includeJobs=true`);

    const errors = errorValidate(response);

    const { data } = response

    return {
      data,
      errors,
    };
  },
  getIndicationsById: async ({ indicationId }) => {
    const response = await api.get(`${baseAPI}/${indicationId}`);

    const errors = errorValidate(response);

    const { data } = response

    return {
      data,
      errors,
    };
  },
  getIndicationsByJobId: async ({ jobId, companyEmail = '' }) => {
    const response = await api.get(`${baseAPI}/IndicationsByJobId`, { params: { jobId, companyEmail } });

    const errors = errorValidate(response);

    const { data } = response

    return {
      data,
      errors,
    };
  },
  getJobsIRecommendedPerson: async () => {
    const response = await api.get(`${baseAPI}/JobsIRecommendedPerson`);

    const errors = errorValidate(response);

    const { data } = response

    return {
      data,
      errors,
    };
  },
  getRecommendationsByJob: async ({ jobId }) => {
    const response = await api.get(`${baseAPI}/RecommendationsByJob?jobId=${jobId}`);

    const errors = errorValidate(response);

    const { data } = response

    return {
      data,
      errors,
    };
  },
  getJobsIWasIndicatedPerson: async () => {
    const response = await api.get(`${baseAPI}/JobsIWasIndicatedPerson`);

    const errors = errorValidate(response);

    const { data } = response

    return {
      data,
      errors,
    };
  },
  getIndicationsIReceivedByJob: async ({ jobId }) => {
    const response = await api.get(`${baseAPI}/IndicationsIReceivedByJob?jobId=${jobId}`);

    const errors = errorValidate(response);

    const { data } = response

    return {
      data,
      errors,
    };
  },
  setFavorite: async ({ indicationId, jobId, personEmail }) => {
    const response = await api.put(`${baseAPI}`, { indicationId, jobId, personEmail });

    const errors = errorValidate(response);

    const { data } = response

    return {
      data,
      errors,
    };
  },
  updateIndicationStatus: async ({
    indicationId,
    indicationStatusId,
    agreedSalaryAmount,
    companyEmail,
  }) => {
    const response = await api.put(
      `${baseAPI}/${indicationId}/update-status`,
      {
        indicationId,
        indicationStatusId,
        agreedSalaryAmount,
        companyEmail
      }
    );

    const errors = errorValidate(response);

    const { data } = response

    return {
      data,
      errors,
    };
  },
  resendEmail: async ({ indicationId }) => {
    const response = await api.post(
      `${baseAPI}/resend-email/${indicationId}`,
    );

    const errors = errorValidate(response);

    const { data } = response

    return {
      data,
      errors,
    };
  },
};
